var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36901_51916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.00195 7.34375C4.00195 5.45813 4.00195 4.51532 4.58774 3.92954C5.17353 3.34375 6.11634 3.34375 8.00195 3.34375H10.002C11.8876 3.34375 12.8304 3.34375 13.4162 3.92954C14.002 4.51532 14.002 5.45813 14.002 7.34375V10.6771C14.002 12.5627 14.002 13.5055 13.4162 14.0913C12.8304 14.6771 11.8876 14.6771 10.002 14.6771H8.00195C6.11634 14.6771 5.17353 14.6771 4.58774 14.0913C4.00195 13.5055 4.00195 12.5627 4.00195 10.6771V7.34375Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.00195 12.6771C2.89738 12.6771 2.00195 11.7817 2.00195 10.6771V6.67708C2.00195 4.16293 2.00195 2.90585 2.783 2.1248C3.56405 1.34375 4.82113 1.34375 7.33529 1.34375H10.002C11.1065 1.34375 12.002 2.23918 12.002 3.34375",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36901_51916"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.5f9c92fb98b23dd9ec60f8f6ae898172.svg";
export { ForwardRef as ReactComponent };